import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

import { ICustomerReference } from 'models/User';
import { ITokenProvider } from './authenticationService';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.locale('sv');

export interface IAEHierarchyItem {
  children: IAEHierarchyItem[];
  default: boolean;
  id: string;
  name: string;
  parentId: string;
}

export interface IHierarchyItem {
  children: IHierarchyItem[];
  default: boolean;
  id: string;
  name: string;
  parentId: string;
}

export interface IUserService {
  GetAEHierarchy: () => Promise<IAEHierarchyItem[]>;
  GetRelatedCustomerHierarchy: (customerId: string) => Promise<IHierarchyItem[]>;
  GetCustomerReference: (customerId: string) => Promise<ICustomerReference>;
  SearchForCustomersReference: (searchText: string) => Promise<ICustomerReference[]>;
  // validateOrder : (order:IOrder) => StructError|null;
}

const userServiceFactory: (
  ApiHostBaseUrl: string,
  authenticationService: ITokenProvider
) => IUserService = (ApiHostBaseUrl: string, authenticationService: ITokenProvider) => {
  return {
    GetCustomerReference: async (customerId: string) => {
      const accessToken = await authenticationService.getOrRenewNativeToken();
      var url: string =
        ApiHostBaseUrl + '/CustomerPortal/GetCustomerReference?CustomerId=' + customerId;
      const data = await fetch(url, {
        method: 'GET',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache',
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + accessToken,
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
      });
      return await (data.json() as Promise<ICustomerReference>);
    },
    SearchForCustomersReference: async (searchText: string) => {
      const accessToken = await authenticationService.getOrRenewNativeToken();
      const url: string = `${ApiHostBaseUrl}/customer/top?q=${encodeURIComponent(searchText)}`;
      const data = await fetch(url, {
        method: 'GET',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache',
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + accessToken,
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
      });
      if (!data.ok) {
        throw new Error(`Could not search for customers, the server responded ${data.status}`);
      }
      return await (data.json() as Promise<ICustomerReference[]>);
    },
    GetAEHierarchy: async () => {
      var url: string = `${ApiHostBaseUrl}/customer/units`;
      const accessToken = await authenticationService.getOrRenewNativeToken();
      const data = await fetch(url, {
        method: 'GET',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache',
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + accessToken,
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
      });
      return await (data.json() as Promise<IAEHierarchyItem[]>);
    },
    GetRelatedCustomerHierarchy: async (customerId: string) => {
      const accessToken = await authenticationService.getOrRenewNativeToken();
      var url: string = `${ApiHostBaseUrl}/customer/${customerId}/hierarchy`;
      const data = await fetch(url, {
        method: 'GET',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache',
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'bearer ' + accessToken,
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
      });
      return await (data.json() as Promise<IHierarchyItem[]>);
    },
  };
};

export default userServiceFactory;
